const d = () => typeof window < "u";
export {
  d as default
};
//# sourceMappingURL=window.js.map
